const header = {
    state: {
        canScroll: true,
        current: 1,
        currentPath: '',
    },
    mutations: {
        changeScrollStatus(state) {
            state.canScroll = !state.canScroll;
        },
        changeCurrent(state,value) {
            state.current = value;
        },
        changeCurrentPath(state,path) {
            state.currentPath = path;
        }
    }
}
export default header;


// WEBPACK FOOTER //
// ./src/store/module/header.js